const getters = {
  industryList: state => {
    let industryArray = []
    state.industryList.forEach(indus => {
      industryArray.push({ industryGB: indus.industryGB ? indus.industryGB : indus.industryEN })
    })
    return industryArray
  },
  showVideoModal: state => {
    return state.showVideoModal
  },
}

export default getters
